import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'

class Text extends Component {
    _change({ target }) {
        this.props.dispatch({ type: 'CHANGE_TEXT', key: this.props.Key, newValue: target.value })
    }

    _blur({ target }) {
        this.props.dispatch({ type: 'SAVE_TEXT', key: this.props.Key })
    }

    render() {
        const { textValue, cognito } = this.props;

        return !cognito.user ? textValue : (
            <input type="text" className="editable" onBlur={this._blur.bind(this)} onChange={this._change.bind(this)} value={textValue} />
        )
    }
}

export default connect(
    ({ cognito, app }, { Key }) => {
        let text = _.find(app.texts, { Key });
        if(text) text = text.Value
        else text = null

        return {
            textValue: text,
            cognito
        }
    }
)( Text )



// WEBPACK FOOTER //
// ./src/components/commons/Text.js